import { render, staticRenderFns } from "./crmAdmissionList.vue?vue&type=template&id=406b4584"
import script from "./crmAdmissionList.vue?vue&type=script&lang=js"
export * from "./crmAdmissionList.vue?vue&type=script&lang=js"
import style0 from "./crmAdmissionList.vue?vue&type=style&index=0&id=406b4584&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports